import './index.css';
import App from './App';
import ReactDOM from 'react-dom';
import { integrations } from 'config';
import { getEnvironment } from 'utils';
import * as Sentry from '@sentry/browser';
import packageInfo from '../package.json';

const ignoreErrors = [
  "Cannot read property 'getBoundingClientRect' of null",
  "Cannot read properties of null (reading 'getBoundingClientRect')",
  "null is not an object (evaluating 'n.container.getBoundingClientRect')",
  "TypeError: null is not an object (evaluating 'n.container.getBoundingClientRect')",
  'EvalError',
  'ResizeObserver loop limit exceeded',
];

const environment = getEnvironment();

const enableSentryPlugins = integrations?.deployment === 'development';

if (integrations?.logging) {
  Sentry.init({
    release: `${packageInfo.name}@${packageInfo.version}`,
    environment,
    dsn: integrations.sentry,
    ignoreErrors,
    beforeSend(event) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        Sentry.showReportDialog();
      }
      return event;
    },
    replaysOnErrorSampleRate: 1.0,
    integrations: enableSentryPlugins
      ? [Sentry.browserTracingIntegration(), Sentry.replayIntegration()]
      : [],
  });
}

ReactDOM.render(<App />, document.getElementById('root'));
